import { theme } from '~/theme';

export const useSXStyles = () => {
  return {
    dialog: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateAreas: '"icon title close"',
      alignItems: 'center',
    },
    icon: {
      gridArea: 'icon',
      display: 'flex',
      marginRight: theme.spacing(1),
    },
    title: {
      gridArea: 'title',
    },
    close: {
      gridArea: 'close',
      margin: theme.spacing(-1, -1, -1, 1),
    },
  };
};
